(function () {
    $(document).ready(function () {

        $featuredCollapsibleArea = $('.js-featured-collapsible-area-trigger');
        $featuredCloseButton = $('.js-collapsible-feature-close');
        $featuredCollapsiblePanel = $('.js-featured-collapsible-trigger');

        //close button
        $featuredCloseButton.click(function () {
            $featuredCollapsibleArea.slideUp("slow");
        });

        //open featured content
       $featuredCollapsiblePanel.click(function () {
            //$featuredCollapsibleArea.slideUp('slow');
			var targetid = $(this).data('itemid');
			//alert(targetid)
            //Do Ajax call and then do slideDown after response
			$.ajax({
			    url: window.location.href,
			    type: "POST",
			    context: this,
			    data: { scController: "Offices", scAction: "GetOfficeOverview", officeid: targetid },
			    success: function (data) {
			        // do stuff
			        //alert(data);
			        $("#targetdiv").html(data);
			        //document.write(data);
			        $featuredCollapsibleArea.slideDown('slow');
			        $("html, body").animate({
			            scrollTop: $("#topdiv").offset().top - 50
			        }, "slow");
			    },
			    error: function (data) {
			        console.log("error", data);
			    }
			});
            //$featuredCollapsibleArea.slideDown('slow');
        });
    });
})();